// d4rkvoids storefront
(function(){

  // Scroll to top on every page load
  window.scrollTo(0, 0);

  // LA clock in header
  function tickClock(){
    var el = document.getElementById('la-clock');
    if(!el) return;
    try {
      var now = new Date();
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        month: '2-digit', day: '2-digit', year: 'numeric',
        hour: 'numeric', minute: '2-digit', hour12: true
      });
      el.textContent = fmt.format(now).toLowerCase().replace(',', '');
    } catch(e){}
  }
  tickClock();
  setInterval(tickClock, 30000);

  // Live cart count
  function updateCartCount(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll('[data-cart-count], .cart-count, .cart__count')
          .forEach(function(n){ n.textContent = c.item_count; });
      })
      .catch(function(){});
  }
  updateCartCount();
  document.addEventListener('cart:updated', updateCartCount);

})();

